import { GET_DEPARTAMENTS, ERROR_DEPARTAMENTS } from "./types";
import { firebase } from "../../firebase";

export const getAlldepartaments = () => async (dispatch) => {
  try {
    let db = firebase.firestore();
    let states = [];
    await db
      .collection("deliveryZones")
      .doc("honduras")
      .collection("states")
      .where("enabled", "==", true)
      .get()
      .then((querySnapshot1) => {
        querySnapshot1.docs.map((doc) => {
          const { name } = doc.data();

          console.log(name);
          return states.push({
            id: doc.id,
            text: name,
            value: JSON.stringify({ id: doc.id, ...doc.data() }),
          });
        });
      });

    dispatch({
      type: GET_DEPARTAMENTS,
      payload: states,
    });
  } catch (error) {
    dispatch({
      type: ERROR_DEPARTAMENTS,
      payload: error.message,
    });
  }
};
